import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { ArrowLeft, CheckCircle2 } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [err, setErr] = useState("");
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (!token) {
      setErr("Kein Token übergeben. Bitte fordere den Link erneut an.");
      return;
    }
    if (password.length < 6) {
      setErr("Das Passwort muss mindestens 6 Zeichen haben.");
      return;
    }
    if (password !== confirm) {
      setErr("Die Passwörter stimmen nicht überein.");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
      setTimeout(() => nav("/login"), 2500);
    } catch (e) {
      setErr(formatApiError(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-6 py-16">
      <div className="w-full max-w-md">
        <Link
          to="/login"
          className="inline-flex items-center gap-2 text-sm text-white/60 hover:text-[#CCFF00] mb-6 transition-colors"
        >
          <ArrowLeft className="w-4 h-4" />
          Zurück zum Login
        </Link>
        <div className="font-display text-xs tracking-[0.3em] text-[#CCFF00] mb-3">
          / NEUES PASSWORT
        </div>

        {done ? (
          <div data-testid="reset-done-state">
            <div className="w-12 h-12 border border-[#CCFF00]/40 bg-[#CCFF00]/10 flex items-center justify-center rounded-sm mb-6">
              <CheckCircle2 className="w-6 h-6 text-[#CCFF00]" />
            </div>
            <h1 className="font-heading font-black text-3xl leading-tight tracking-tight mb-4">
              Passwort geändert.
            </h1>
            <p className="text-white/70">
              Du wirst gleich automatisch zum Login weitergeleitet …
            </p>
          </div>
        ) : (
          <>
            <h1 className="font-heading font-black text-4xl leading-tight tracking-tight mb-8">
              Neues Passwort vergeben.
            </h1>
            <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
              <div>
                <label className="font-display text-xs tracking-widest text-white/60 block mb-2">
                  Neues Passwort (min. 6 Zeichen)
                </label>
                <input
                  data-testid="reset-password"
                  type="password"
                  required
                  minLength={6}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full bg-[#111214] border border-white/10 rounded-md px-4 py-3 text-white focus:border-[#CCFF00] outline-none"
                />
              </div>
              <div>
                <label className="font-display text-xs tracking-widest text-white/60 block mb-2">
                  Passwort wiederholen
                </label>
                <input
                  data-testid="reset-confirm"
                  type="password"
                  required
                  value={confirm}
                  onChange={(e) => setConfirm(e.target.value)}
                  className="w-full bg-[#111214] border border-white/10 rounded-md px-4 py-3 text-white focus:border-[#CCFF00] outline-none"
                />
              </div>
              {err && (
                <div data-testid="reset-error" className="text-sm text-red-400">
                  {err}
                </div>
              )}
              <button
                data-testid="reset-submit"
                disabled={loading}
                className="btn-primary w-full justify-center"
              >
                {loading ? "Wird gespeichert …" : "Passwort speichern"}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
